import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import { BRAND, DISPLAY_STYLE } from '../theme'
import { BrandLogo } from './BrandLogo'
import { VersionLabel } from './VersionLabel'

// Drawer header on navy: the JP mark and "JuPi" at full height. An app
// label (e.g. Admin) is layered over the wordmark's lower right, level
// with the foot of the mark. The version sits at the bottom right; the
// environment is BuildStrip. `compact` is the phone app bar size.
export function BrandHeader({ label, compact }: { label?: string; compact?: boolean }) {
  const { t } = useTranslation()
  return (
    <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 1.25, minWidth: 0, width: compact ? 'auto' : '100%', alignSelf: 'stretch' }}>
      {compact ? null : (
        <Box sx={{ position: 'absolute', bottom: 6, right: -8, lineHeight: 1 }}>
          <VersionLabel />
        </Box>
      )}
      <BrandLogo variant="mark" onDark height={compact ? 28 : 36} sx={{ flexShrink: 0 }} />
      <Box sx={{ position: 'relative', display: 'flex' }}>
        <Typography
          component="span"
          sx={{ ...DISPLAY_STYLE, textTransform: 'none', fontWeight: 800, fontSize: compact ? '1.5rem' : '1.9rem', lineHeight: 1 }}
          noWrap
        >
          {t('app.name')}
        </Typography>
        {label ? (
          <Typography
            component="span"
            sx={{
              ...DISPLAY_STYLE,
              position: 'absolute',
              right: 0,
              bottom: -10,
              fontWeight: 600,
              fontSize: '0.65rem',
              letterSpacing: '0.12em',
              lineHeight: 1,
              color: BRAND.beaconAmber,
            }}
          >
            {label}
          </Typography>
        ) : null}
      </Box>
      {compact ? (
        <Box sx={{ alignSelf: 'flex-end', pb: 0.25, lineHeight: 1 }}>
          <VersionLabel />
        </Box>
      ) : null}
    </Box>
  )
}
